import React from "react";
import uuid from "react-uuid";
import CustomersFilesWidget from "../../Customers/CustomersFilesWidget";
import CustomerInfoWidget from "../../Customers/CustomerInfoWidget";
import MachinesListWidget from "../../Customers/MachinesListWidget";
import MachineFilesWidget from "../../Customers/MachineFilesWidget";
import NetworkDiagramWidget from "../../NetworkDiagram/NetworkDiagramWidget";
import CustomerGatewayWidget from "../../NetworkGateway/CustomerGatewayWidget";
import MachineGatewayWidget from "../../NetworkGateway/MachinGatewayWidget";
import ServiceCallWidget from "../../ServiceCalls/ServiceCallsGridWidget";
import ServiceAgreementWidget from "../../ServiceAgreements/ServiceAgreementGridWidget";
import MachineInfoWidget from "../../MachineInfo/MachineInfoWidget";
import MachinePicturesWidget from "../../MachinePictures/MachinePicturesWidget";
import WarrantyWidget from "../../Warranties/WarrantyGridWidget";
import SupportCasesWidget2 from "../../SupportCases2/SupportCasesGridWidget";
import DeviceListWidget from "../../DeviceList/DeviceListGridWidget";
import SparePartsWidget from "../../Spareparts/SparepartsWidget";
import RunTimeWidget from "../../RunTimes/RunTimeWidget";
import MachineDetailsWidget from "../../MachineDetails/MachineDetailsWidget";

export const widgetLibrary = [
  {
    name: "CustomerInfoWidget",
    label: "Customer Information",
    sidebarItems: [],
    group: "All",
    dashboardId: "1001",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <CustomerInfoWidget
        key={uuid()}
        id="1001"
        header="Customer Information"
        infoId="SV1001"
        {...props}
      />
    ),
  },
  {
    name: "MachineListWidget",
    label: "Machine List",
    sidebarItems: [],
    group: "All",
    dashboardId: "1002",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <MachinesListWidget
        key={uuid()}
        id="1002"
        header="Machines"
        infoId="SV1002"
        {...props}
      />
    ),
  },
  {
    name: "CustomerGatewayWidget",
    label: "Remote Gateway Information",
    sidebarItems: [],
    group: "Customer",
    dashboardId: "1003",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <CustomerGatewayWidget
        key={uuid()}
        id="1003"
        header="Remote Gateway Information"
        infoId="SV1003"
        {...props}
      />
    ),
  },
  {
    name: "CustomersFilesWidget",
    label: "Customer Files",
    sidebarItems: [],
    group: "All",
    dashboardId: "1004",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <CustomersFilesWidget
        key={uuid()}
        id="1004"
        header="Customer Files"
        infoId="SV1004"
        {...props}
      />
    ),
  },
  {
    name: "NetworkDiagramWidget",
    label: "Network Diagram",
    sidebarItems: [],
    group: "All",
    dashboardId: "1005",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <NetworkDiagramWidget
        key={uuid()}
        id="1005"
        header="Network Diagram"
        infoId="SV1005"
        thumb={true}
        {...props}
      />
    ),
  },
  {
    name: "ServiceCallWidget",
    label: "Service Calls",
    sidebarItems: [],
    group: "All",
    dashboardId: "1006",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <ServiceCallWidget
        key={uuid()}
        id="1006"
        header="Service Calls"
        infoId="SV1006"
        {...props}
      />
    ),
  },
  {
    name: "ServiceAgreementWidget",
    label: "Service Agreements",
    sidebarItems: [],
    group: "Customer",
    dashboardId: "1007",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <ServiceAgreementWidget
        key={uuid()}
        id="1007"
        header="Service Agreements"
        infoId="SV1007"
        {...props}
      />
    ),
  },
  {
    name: "ServiceReportsWidget",
    label: "Service Reports",
    sidebarItems: [],
    group: "All",
    dashboardId: "1008",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <ServiceAgreementWidget
        key={uuid()}
        id="1008"
        header="Archive Service Reports"
        infoId="SV1008"
        {...props}
      />
    ),
  },
  {
    name: "WarrantyWidget",
    label: "Warranties",
    sidebarItems: [],
    group: "Customer",
    dashboardId: "1009",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <WarrantyWidget
        key={uuid()}
        id="1009"
        header="Warranties"
        infoId="SV1009"
        {...props}
      />
    ),
  },
  //{
  //  name: "SupportCasesWidget",
  //  label: "Support Cases",
  //  sidebarItems: [],
  //  group: "All",
  //  dashboardId: "1010",
  //  imageUrl: "../../assets/img/grid.png",
  //  inUse: false,
  //  component: (props) => (
  //    <SupportCasesWidget
  //      key={uuid()}
  //      id="1010"
  //      header="Support Cases"
  //      infoId="SV1010"
  //      {...props}
  //    />
  //  ),
  //},
  {
    name: "MachineGatewayWidget",
    label: "Remote Gateway Information",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2001",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <MachineGatewayWidget
        key={uuid()}
        id="2001"
        header="Remote Gateway Information"
        infoId="SV2001"
        {...props}
      />
    ),
  },
  {
    name: "RunTimeWidget",
    label: "Assembly Device On/Run Time Totals",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2002",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <RunTimeWidget
        key={uuid()}
        id="2002"
        header="Assembly Device On/Run Time Totals"
        infoId="SV2002"
        {...props}
      />
    ),
  },
  {
    name: "DeviceListWidget",
    label: "Assembly Devices",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2003",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <DeviceListWidget
        key={uuid()}
        id="2003"
        header="Assembly Devices"
        infoId="SV2003"
        {...props}
      />
    ),
  },

  {
    name: "MachineFilesWidget",
    label: "Machine Files",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2007",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <MachineFilesWidget
        key={uuid()}
        id="2007"
        header="Machine Files"
        infoId="SV2007"
        {...props}
      />
    ),
  },
  {
    name: "MachineInfoWidget",
    label: "Machine Info",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2008",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <MachineInfoWidget
        key={uuid()}
        id="2008"
        header="Machine Info"
        infoId="SV2008"
        {...props}
      />
    ),
  },
  {
    name: "SparePartsWidget",
    label: "Spare part links",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2009",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <SparePartsWidget
        key={uuid()}
        id="2009"
        header="Spare part links"
        infoId="SV2009"
        {...props}
      />
    ),
  },
  {
    name: "MachinePicturesWidget",
    label: "Machine Pictures",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2004",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <MachinePicturesWidget
        key={uuid()}
        id="2004"
        header="Machine Pictures"
        infoId="SV2004"
        {...props}
      />
    ),
  },
  {
    name: "MachineDetailsWidget",
    label: "Assembly Details",
    sidebarItems: [],
    group: "Machine",
    dashboardId: "2010",
    imageUrl: "../../assets/img/grid.png",
    inUse: false,
    component: (props) => (
      <MachineDetailsWidget
        key={uuid()}
        id="2010"
        header="Assembly Details"
        infoId="SV2010"
        {...props}
      />
    ),
    }, {
        name: "SupportCasesWidget2",
        label: "Support Cases",
        sidebarItems: [],
        group: "All",
        dashboardId: "101000",
        imageUrl: "../../assets/img/grid.png",
        inUse: false,
        component: (props) => (
            <SupportCasesWidget2
                key={uuid()}
                id="101000"
                header="Support Cases"
                infoId="SV1010"
                {...props}
            />
        ),
    },
];
